import { UserEntityProfileType } from "../user/user-entity-profile-type.model"


export class AuthorityBase {
	authority: number = -1

	//the attributes are depending of the concrete authority
	attributes: any

	static fromAuthority(authority: Authority): AuthorityBase {
		let current = new AuthorityBase()
		Object.assign(current, authority)
		
		if ((<any>authority).authority == "ADMIN") {
			current.authority = UserEntityProfileType.ADMIN.valueOf()
		}
		if ((<any>authority).authority == "ENS_MANAGER") {
			current.authority = UserEntityProfileType.ENS_MANAGER.valueOf()
		}
		if ((<any>authority).authority == "SERVICE_MANAGER") {
			current.authority = UserEntityProfileType.SERVICE_MANAGER.valueOf()
		}
		if ((<any>authority).authority == "SIGNER") {
			current.authority = UserEntityProfileType.SIGNER.valueOf()
		}
		if ((<any>authority).authority == "SUPPORT") {
			current.authority = UserEntityProfileType.SUPPORT.valueOf()
		}
		if ((<any>authority).authority == "USER") {
			current.authority = UserEntityProfileType.USER.valueOf()
		}
		return current
	}

}

export interface Authority extends AuthorityBase {

}